import TextM from "@common/components/text/TextM"
import { theme } from "@common/theme/theme"
import React from "react"
import { View } from "react-native"
import FontAwesome5 from "react-native-vector-icons/FontAwesome5"

const StudentsListStringForOccurrence = (props) => {
    const {
        liveSession,
        occurrence,
        style = {},
        forceDisplayName = false,
    } = props

    const nextOccurrences = liveSession?.next_occurrences
    const occ = occurrence
    const allTemporaryAddedUsers = nextOccurrences?.reduce((acc, occ) => {
        const temporaryAddedUsers =
            occ?.added_users
                ?.map((x) => {
                    return { ...x, temporarilyAdded: true }
                })
                .filter((u) => u?.class) ?? []
        return [...acc, ...temporaryAddedUsers]
    }, [])

    const allTemporaryRemovedUsers = nextOccurrences?.reduce((acc, occ) => {
        const temporaryRemovedUsers =
            occ?.removed_users
                ?.map((x) => {
                    return { ...x, temporarilyRemoved: true }
                })
                .filter((u) => u?.class) ?? []
        return [...acc, ...temporaryRemovedUsers]
    }, [])

    const temporaryAddedUsers =
        occ?.added_users
            ?.map((x) => {
                return { ...x, temporarilyAdded: true }
            })
            .filter((u) => u?.class) ?? []

    const temporaryRemovedUsers =
        occ?.removed_users
            ?.map((x) => {
                return { ...x, temporarilyRemoved: true }
            })
            .filter((u) => u?.class) ?? []

    // temporary removed users that are not removed on this occurrence
    const temporaryRemovedButNotOnThisOcc =
        allTemporaryRemovedUsers
            ?.filter(
                (user) =>
                    !occ?.removed_users?.some(
                        (removedUser) => removedUser.id === user.id
                    )
            )
            ?.map((x) => ({ ...x, temporarilyRemoved: false })) ?? []

    const students =
        liveSession?.students ??
        liveSession?.users?.filter((user) => !user?.is_tutor) ??
        []

    // Get reserved students (pending) and mark them with reservation tags
    const reservedStudents =
        liveSession?.reservations?.map((reservation) => ({
            ...reservation.user,
            is_reservation: true,
            is_adhoc: reservation.mode === "adhoc",
        })) ?? []

    const studentsList = [
        ...temporaryAddedUsers,
        ...temporaryRemovedUsers,
        ...temporaryRemovedButNotOnThisOcc,
        ...(students?.filter(
            (user) =>
                !temporaryAddedUsers?.some(
                    (tempUser) => tempUser.id === user.id
                ) &&
                !temporaryRemovedUsers.some(
                    (tempUser) => tempUser.id === user.id
                ) &&
                !temporaryRemovedButNotOnThisOcc.some(
                    (tempUser) => tempUser.id === user.id
                ) &&
                !allTemporaryAddedUsers.some(
                    (tempUser) => tempUser.id === user.id
                ) &&
                !user?.is_tutor
        ) ?? []),
        ...reservedStudents,
    ]?.filter(
        (user, index, self) => index === self.findIndex((u) => u.id === user.id)
    )
    return (
        <View
            style={{
                flexDirection: "row",
                alignItems: "center",
                marginTop: 5,
                flexWrap: "wrap",
                paddingHorizontal: 3,
                ...style,
            }}
        >
            {studentsList?.length > 0 &&
                studentsList?.map((s, index) => {
                    const isPaymentBlocked = s?.is_payment_blocked
                    const attendanceFlag = liveSession?.attendance_flags?.find(
                        (flag) =>
                            flag.user_id === s?.id && flag?.date === occ?.date
                    )
                    const attendanceFlagString = isPaymentBlocked
                        ? "(impayé.e)"
                        : attendanceFlag?.type
                          ? attendanceFlag?.type === "late"
                              ? `(retard)`
                              : "(abs.)"
                          : ""
                    const attendanceFlagColor = isPaymentBlocked
                        ? theme.colors.warning
                        : !attendanceFlag
                          ? theme.colors.grey
                          : attendanceFlag?.type === "late"
                            ? theme.colors.warning
                            : theme.colors.error

                    return (
                        <View
                            style={{
                                flexDirection: "row",
                                alignItems: "center",
                            }}
                            key={index}
                        >
                            {(s.temporarilyRemoved || s.temporarilyAdded) && (
                                <FontAwesome5
                                    name={"clock"}
                                    size={12}
                                    color={theme.colors.primary}
                                />
                            )}
                            {isPaymentBlocked && (
                                <FontAwesome5
                                    name={"lock"}
                                    size={10}
                                    color={theme.colors.warning}
                                    style={{ marginRight: 2 }}
                                />
                            )}
                            {s.is_reservation && (
                                <FontAwesome5
                                    name={"book"}
                                    size={10}
                                    color={
                                        s.is_adhoc
                                            ? theme.colors.warning
                                            : theme.colors.info
                                    }
                                    style={{ marginRight: 2 }}
                                />
                            )}
                            <TextM
                                color={
                                    s.is_reservation
                                        ? theme.colors.grey
                                        : attendanceFlagColor
                                }
                                fontSize={12}
                                fontWeight={
                                    s.temporarilyAdded
                                        ? "SemiBold"
                                        : s.is_reservation
                                          ? "LightItalic"
                                          : "Regular"
                                }
                                style={{
                                    textDecorationLine: s.temporarilyRemoved
                                        ? "line-through"
                                        : "none",
                                    marginHorizontal: 2,
                                }}
                                wrap
                            >
                                {(s?.firstname && !forceDisplayName
                                    ? s?.firstname + " " + s?.lastname
                                    : s?.display_name) +
                                    " " +
                                    (s.profile?.class ?? s?.class)}{" "}
                                {attendanceFlagString !== "" ? (
                                    <TextM
                                        fontSize={9}
                                        color={attendanceFlagColor}
                                    >
                                        {attendanceFlagString}
                                    </TextM>
                                ) : (
                                    ""
                                )}
                                {index < studentsList.length - 1 ? ", " : ""}
                            </TextM>
                        </View>
                    )
                })}
            {studentsList?.length === 0 && (
                <TextM
                    color={theme.colors.grey}
                    fontSize={12}
                    style={{ marginHorizontal: 2 }}
                    fontWeight={"LightItalic"}
                    wrap
                >
                    (aucun élève)
                </TextM>
            )}
        </View>
    )
}

export default StudentsListStringForOccurrence
